import React from "react";
import { Grid, MenuItem } from "@material-ui/core";
import C1InputField from "app/c1component/C1InputField";
import C1SelectField from "app/c1component/C1SelectField";
import { countryList } from "app/sctcomponent/SctConstant";

const fieldInputProps = (maxLength, placeHolder) => ({ maxLength, placeHolder });

const ManageOwnUserDetail = ({
    inputData,
    handleInputChange,
    handleInputChangeDeep,
    isDisabled,
    errors,
}) => {
    const handleInputChangeDeepWrap = (e) => {
        handleInputChangeDeep(e.target.name, e.target.value);
    };

    const handleInputChangeContactNo = (e) => {
        const inputValue = e.target.value || "";
        const numericValue = inputValue.replace(/[^\d]/g, '');
        handleInputChange({ target: { name: 'accnrAplTel', value: numericValue } });
    };

    return (
        <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
                <C1InputField
                    label="Full Name"
                    name="accnrAplName"
                    disabled={isDisabled}
                    required
                    inputProps={fieldInputProps(35, 'Enter full name')}
                    onChange={handleInputChange}
                    value={inputData.accnrAplName || ""}
                    error={errors['accnrAplName'] !== undefined}
                    helperText={errors['accnrAplName'] || ''}
                />
                <C1InputField
                    label="Position"
                    name="accnrAplTitle"
                    disabled={isDisabled}
                    required
                    inputProps={fieldInputProps(35, 'Enter job title')}
                    onChange={handleInputChange}
                    value={inputData.accnrAplTitle || ""}
                    error={errors['accnrAplTitle'] !== undefined}
                    helperText={errors['accnrAplTitle'] || ''}
                />
                <C1InputField
                    label="Contact No"
                    name="accnrAplTel"
                    disabled={isDisabled}
                    required
                    inputProps={fieldInputProps(35, '+251 9XX XXX XXX')}
                    onChange={handleInputChangeContactNo}
                    value={inputData.accnrAplTel || ""}
                    error={errors['accnrAplTel'] !== undefined}
                    helperText={errors['accnrAplTel'] || ''}
                />
                <C1InputField
                    label="Province"
                    name="accnrAplProv"
                    disabled={isDisabled}
                    required
                    inputProps={fieldInputProps(30, 'Select province')}
                    onChange={handleInputChange}
                    value={inputData.accnrAplProv || ""}
                    error={errors['accnrAplProv'] !== undefined}
                    helperText={errors['accnrAplProv'] || ''}
                />
                <C1InputField
                    label="Postal Code"
                    name="accnrAplPcode"
                    disabled={isDisabled}
                    required={false}
                    inputProps={fieldInputProps(10, 'Enter postal code')}
                    onChange={handleInputChange}
                    value={inputData.accnrAplPcode || ""}
                    error={errors['accnrAplPcode'] !== undefined}
                    helperText={errors['accnrAplPcode'] || ''}
                />
            </Grid>

            <Grid item xs={12} md={6}>
                <C1InputField
                    label="ID / Passport No."
                    name="accnrAplPassNid"
                    disabled={isDisabled}
                    required
                    inputProps={fieldInputProps(20, 'Enter identification number')}
                    onChange={handleInputChange}
                    value={inputData.accnrAplPassNid || ""}
                    error={errors['accnrAplPassNid'] !== undefined}
                    helperText={errors['accnrAplPassNid'] || ''}
                />
                <C1InputField
                    label="Email"
                    name="accnrAplEmail"
                    disabled={isDisabled}
                    required
                    inputProps={fieldInputProps(128, 'name@example.com')}
                    onChange={handleInputChange}
                    value={inputData.accnrAplEmail || ""}
                    error={errors['accnrAplEmail'] !== undefined}
                    helperText={errors['accnrAplEmail'] || ''}
                />
                <C1InputField
                    label="Address Line 1"
                    name="accnrAplAddr1"
                    disabled={isDisabled}
                    required
                    inputProps={fieldInputProps(64, 'Street address')}
                    onChange={handleInputChange}
                    value={inputData.accnrAplAddr1 || ""}
                    error={errors['accnrAplAddr1'] !== undefined}
                    helperText={errors['accnrAplAddr1'] || ''}
                />
                <C1InputField
                    label="City / District"
                    name="accnrAplCity"
                    disabled={isDisabled}
                    required
                    inputProps={fieldInputProps(30, 'Select city or district')}
                    onChange={handleInputChange}
                    value={inputData.accnrAplCity || ""}
                    error={errors['accnrAplCity'] !== undefined}
                    helperText={errors['accnrAplCity'] || ''}
                />
                <C1SelectField
                    label="Country"
                    name="TMstCountryApl.ctyCode"
                    required
                    disabled={isDisabled}
                    onChange={handleInputChangeDeepWrap}
                    value={inputData.TMstCountryApl?.ctyCode || ""}
                    optionsMenuItemArr={countryList.map((item, ind) => (
                        <MenuItem value={item.value} key={ind}>{item.desc}</MenuItem>
                    ))}
                    error={errors['TMstCountryApl'] !== undefined}
                    helperText={errors['TMstCountryApl'] || ''}
                />
            </Grid>
        </Grid>
    );
};

export default ManageOwnUserDetail;
